import { useIntl } from 'react-intl';

import { useDoohReportFormatters } from '@/components/doohReport/common/hooks/useDoohReportFormatters';
import { getCampaignOtaWithoutEvent, stripOtaFigures } from './eventsOta.helpers';

import type { DoohReportEvent } from 'sonata-static-storage/lib/entities/doohReport/doohReport.types';

type Props = {
  event: DoohReportEvent;
  /** Campaign OTA, the plan figure the event moves. */
  campaignOta: number | null;
};

/**
 * "Event impact" cell: the event's effect in absolute terms — the target people it added to the
 * campaign and the campaign OTA without → with it — followed by why it lifted delivery, without the
 * OTA figures the explanation quotes.
 */
export default function OtaReasons({ event, campaignOta }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const { formatCount, formatOta, notAvailable } = useDoohReportFormatters();
  const reasons = stripOtaFigures(event.otaReasons);
  const hasImpact = event.reachAddedPoints !== null && event.reachAddedPoints > 0;
  const campaignOtaWithoutEvent = getCampaignOtaWithoutEvent(campaignOta, event.onTargetUpliftPct);

  if (!hasImpact && !reasons) {
    return <>{notAvailable}</>;
  }

  return (
    <span className="contextEvents__impact">
      {hasImpact && (
        <span>
          <strong className="contextEvents__reasonsOta">
            {formatMessage(
              { defaultMessage: '+{people} target people', id: 'doohReport.contextEvents.impact.targetPeople' },
              { people: formatCount(event.reachAddedPoints) }
            )}
          </strong>
          {campaignOtaWithoutEvent !== null &&
            campaignOta !== null &&
            ` · ${formatMessage(
              { defaultMessage: 'Campaign OTA {without} → {with}', id: 'doohReport.contextEvents.impact.campaignOta' },
              { with: formatOta(campaignOta), without: formatOta(campaignOtaWithoutEvent) }
            )}`}
        </span>
      )}
      {reasons && <span>{reasons}</span>}
    </span>
  );
}
